import { ReactElement, ChangeEvent } from 'react'
import { Switch, Typography, SxProps } from '@mui/material'
import { Box } from '@ui/structure'
import SwitchInfoTooltip, { SwitchInfoTooltipProps } from './components/SwitchInfoTooltip'

export interface SwitchLabeledProps {
  checked: boolean
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  label: string
  labelPlacement?: 'start' | 'end'
  disabled?: boolean
  infoTooltip?: SwitchInfoTooltipProps
  'data-cy'?: string
  sx?: SxProps
  boxSx?: SxProps
}

const SwitchLabeled = ({
  checked,
  onChange,
  label,
  labelPlacement = 'end',
  disabled,
  infoTooltip,
  sx,
  'data-cy': dataCy,
  boxSx,
}: SwitchLabeledProps): ReactElement => {
  return (
    <Box display="flex" alignItems="center" sx={boxSx}>
      {labelPlacement === 'start' && <Typography sx={{ py: 0, px: 1, ...sx }}>{label}</Typography>}
      <Switch
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        size="small"
        data-cy={dataCy}
      />
      {infoTooltip && <SwitchInfoTooltip {...infoTooltip} />}
      {labelPlacement === 'end' && <Typography sx={{ py: 0, px: 1, ...sx }}>{label}</Typography>}
    </Box>
  )
}

export default SwitchLabeled
